import { render, staticRenderFns } from "./BigCarousel.vue?vue&type=template&id=811f1f78"
import script from "./BigCarousel.vue?vue&type=script&lang=js"
export * from "./BigCarousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports